import React, { useEffect, useState } from "react";
import httpService from "../services/httpService"; // your axios wrapper

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { Link } from "react-router-dom";
import Badge from "react-bootstrap/Badge";

import "../styles/dashbaords.scss";
import LoadingFade from "../components/LoadingFade";
import Heading3 from "../components/Heading3";
import { FaSearch, FaTimes, FaUsers, FaHeadphones, FaLightbulb, FaClock, FaMicrophone } from "react-icons/fa";
import PageHero from "../components/PageHero";
import Card from 'react-bootstrap/Card';

const PodcasterDashboard = () => {
    const [loading, setLoading] = useState(true);
    const [podcastClubs, setPodcastClubs] = useState([]);
    const [error, setError] = useState(null);
    const [search, setSearch] = useState('');
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [pagination, setPagination] = useState({ total: 0, totalPages: 1, hasNextPage: false });

    useEffect(() => {
        getDashboardData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageNumber, pageSize]);

    const getDashboardData = (page = pageNumber, searchValue = search) => {
        setLoading(true);
        const params = { pageNumber: page, pageSize, ...(searchValue && { search: searchValue }) };
        httpService.get("/dash/get-data", { params })
            .then((res) => {
                console.log('get dash data', res.data);
                setPodcastClubs(res.data.podcast_clubs || []);
                setPagination({
                    total: res.data.total || 0,
                    totalPages: res.data.totalPages || 1,
                    hasNextPage: res.data.hasNextPage || false,
                });
            })
            .catch((err) => {
                setError(err.response?.data?.message || "Error loading data");
            })
            .finally(() => setLoading(false));
    };

    const handleSearchSubmit = (e) => {
        e.preventDefault();
        setPageNumber(1);
        getDashboardData(1);
    };

    const handleClearSearch = () => {
        setSearch('');
        setPageNumber(1);
        getDashboardData(1, '');
    };

    const formatShortDate = (dateString) => {
        if (!dateString) return 'Not set';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    };

    return (
        <LoadingFade loading={loading} stateKey={loading?'loading':'not-loading'}>

            <PageHero backgroundImage="/img/console-wide2.jpg">
                <div className="d-flex align-items-center gap-3">
                    <FaMicrophone size={30} style={{ opacity: 0.9 }} />
                    <div>
                        <h1 className="page-hero__title mb-1">Your Dashboard</h1>
                        <p className="page-hero__sub mb-0">Manage your podcast clubs and track engagement.</p>
                    </div>
                </div>
            </PageHero>

            <Container className={'my-3'}>
                <Row>
                    <Col sm={12}>
                        {error && (
                            <div className="alert alert-danger">{error}</div>
                        )}

                        <Row className="mb-3 align-items-center">
                            <Col md={5}>
                                <Form onSubmit={handleSearchSubmit}>
                                    <div className="d-flex align-items-center gap-2">
                                        <InputGroup size="sm">
                                            <Form.Control
                                                type="text"
                                                placeholder="Search clubs..."
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                            />
                                            <Button variant="primary" type="submit"><FaSearch /></Button>
                                        </InputGroup>
                                        {search && (
                                            <Button variant="outline-secondary" size="sm" onClick={handleClearSearch}>
                                                <FaTimes />
                                            </Button>
                                        )}
                                    </div>
                                </Form>
                            </Col>
                            <Col md={4} className="d-flex align-items-center justify-content-end gap-2">
                                <Button
                                    as={Link}
                                    to="/wizard/start/new"
                                    variant="primary"
                                    size="sm"
                                    className={'d-block'}
                                >
                                    Create New Podcast Club
                                </Button>
                            </Col>
                            <Col md={3} className="d-flex align-items-center justify-content-end gap-2">
                                <Form.Label className="mb-0 small">Per page:</Form.Label>
                                <Form.Select size="sm" value={pageSize} onChange={(e) => { setPageSize(parseInt(e.target.value)); setPageNumber(1); }} style={{ width: 'auto' }}>
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                </Form.Select>
                            </Col>
                        </Row>

                        {podcastClubs.length === 0 && !error && (
                            <p className="text-muted">No podcast clubs found.</p>
                        )}

                        {podcastClubs.length > 0 && (
                            <>
                                <Row className="g-3">
                                    {podcastClubs.map((club) => (
                                        <Col key={club.id} sm={6}>
                                            <div className="border rounded h-100 d-flex flex-column">
                                                <img
                                                    src={club.super_wide_image || '/img/club-defaults/super-wide.jpg'}
                                                    alt={club.title}
                                                    style={{ width: '100%', height: 'auto', borderRadius: '4px 4px 0 0' }}
                                                />
                                                <div className="p-3 d-flex flex-column flex-grow-1 justify-content-between">
                                                    <div>
                                                        <div className="d-flex justify-content-between align-items-start mb-2">
                                                            <h5 className="mb-0">{club.title}</h5>
                                                            {club.is_testing === 1 && (
                                                                <Badge bg="primary" text="light">Testing</Badge>
                                                            )}
                                                        </div>
                                                        <Row className="g-3 mb-3">
                                                            <Col xs={3}>
                                                                <Card className="text-center h-100 stat-card">
                                                                    <Card.Body className="p-2">
                                                                        <FaUsers className="text-primary mb-1" />
                                                                        <div className="fw-bold">{club.total_listeners || 0}</div>
                                                                        <small className="text-muted">Listeners</small>
                                                                    </Card.Body>
                                                                </Card>
                                                            </Col>
                                                            <Col xs={3}>
                                                                <Card className="text-center h-100 stat-card">
                                                                    <Card.Body className="p-2">
                                                                        <FaHeadphones className="text-primary mb-1" />
                                                                        <div className="fw-bold">{club.episodes_count || 0}</div>
                                                                        <small className="text-muted">Episodes</small>
                                                                    </Card.Body>
                                                                </Card>
                                                            </Col>
                                                            <Col xs={3}>
                                                                <Card className="text-center h-100 stat-card">
                                                                    <Card.Body className="p-2">
                                                                        <FaLightbulb className="text-primary mb-1" />
                                                                        <div className="fw-bold">{club.key_takeaways_count || 0}</div>
                                                                        <small className="text-muted">Key Takeaways</small>
                                                                    </Card.Body>
                                                                </Card>
                                                            </Col>
                                                            <Col xs={3}>
                                                                <Card className="text-center h-100 stat-card">
                                                                    <Card.Body className="p-2">
                                                                        <FaClock className="text-primary mb-1" />
                                                                        <div className="fw-bold">{formatShortDate(club.overall_start_date_time)}</div>
                                                                        <small className="text-muted">Start Date</small>
                                                                    </Card.Body>
                                                                </Card>
                                                            </Col>
                                                        </Row>
                                                        <Row className="g-3">
                                                            <Col sm={9}>
                                                                <div className="d-flex align-items-center gap-2">
                                                                    <div className="flex-grow-1" style={{ height: '8px', backgroundColor: '#e9ecef', borderRadius: '4px', overflow: 'hidden' }}>
                                                                        <div className="engagement-bar-fill" style={{ width: `${club.engagement_bar ?? 0}%`, height: '100%', borderRadius: '4px' }} />
                                                                    </div>
                                                                    <small className="text-muted flex-shrink-0">{club.engagement_bar ?? 0}%</small>
                                                                </div>
                                                                <small className="text-muted">Engagement</small>
                                                            </Col>
                                                            <Col sm={3}>
                                                                <Button
                                                                    as={Link}
                                                                    to={`/podcaster/podcast-club/${club.guid}`}
                                                                    variant="primary"
                                                                    size="sm"
                                                                    className={'d-block'}
                                                                >
                                                                    View Podcast Club
                                                                </Button>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>

                                <Row className="mt-3 align-items-center">
                                    <Col>
                                        <small className="text-muted">
                                            {pagination.total} club{pagination.total !== 1 ? 's' : ''} total
                                        </small>
                                    </Col>
                                    <Col className="d-flex justify-content-end align-items-center gap-2">
                                        <Button variant="outline-primary" size="sm" onClick={() => setPageNumber(p => p - 1)} disabled={pageNumber <= 1}>
                                            Previous
                                        </Button>
                                        <small>Page {pageNumber} of {pagination.totalPages}</small>
                                        <Button variant="outline-primary" size="sm" onClick={() => setPageNumber(p => p + 1)} disabled={!pagination.hasNextPage}>
                                            Next
                                        </Button>
                                    </Col>
                                </Row>
                            </>
                        )}
                    </Col>
                </Row>
            </Container>
        </LoadingFade>
    );
};

export default PodcasterDashboard;
